export const PARTIAL_UPDATE_TYPE = {
  REVERT: 'revert-to-previous-full-deployment-version',
  UPDATE_TO_FULL_DEPLOYMENT: 'update-to-full-deployment',
  UPDATE_TO_FULL_LIBRARY: 'update-to-full-library',
} as const;

export const DEPLOYMENT_FORM_INPUT_WIDTH = '37em';
